import { SubscriberPlansDto } from '@api';
import { ICreatePlan } from '@cake-api/interface/teacher';
import { atom } from 'jotai';

export const SeminarDialogAtom = atom(false);

export const PlanAtom = atom<{
	open: boolean;
	data: SubscriberPlansDto | null;
	subscriberSeminarId?: number | null;
	subscriberSeminar: {
		id: number;
		seminar_id: number;
	} | null;
}>({
	open: false,
	data: null,
	subscriberSeminarId: null,
	subscriberSeminar: null,
});

export const SupportDialogAtom = atom(false);

export const SnackbarAtom = atom<{
	color: string;
	text: string;
	type?: 'success' | 'error' | 'info';
}>({
	text: '',
	type: 'info',
	color: 'green',
});
